var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container d-flex justify-content-center align-items-center flex-column p-10"},[(_vm.version == '1.5.0')?_c('may2022'):_vm._e(),(_vm.version == '1.5.1')?_c('latemay2022'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }